define('app/sds/service/usage/nondiscounted/component/sds-service-usage-nondiscounted-component',["service!selcomm", "$timeout", "$q", "service!sss-site"], function (SelcommWS, $timeout, $q, siteService) {
	return {
		// Require specifies controllers to look for
		// These will be bound to your controller on PostLink (After the constructor) Tezt
		require: {

		},
		transclude: false,
		controller: {
			bind: {
				"service": "="
			},
			// Define functions here and default properties that are simple types (not objects or arrays)
			prototype: {
				currentPeriodOnly: true,
				hide: true,
                loadUsageItems: function loadUsageItems(serviceReference, billPeriod) {
                    if (angular.isUndefined(billPeriod) || billPeriod === null) {
                        return SelcommWS.get("Service", "NonDiscountedUsageDisplayList", {
                            ServiceRef: serviceReference
                        });
                    }
                    else {
                        return SelcommWS.get("Service", "NonDiscountedUsageDisplayListForBillPeriod", {
                            ServiceRef: serviceReference,
                            BillPeriod: billPeriod
                        });
                    }
                },
                getBillPeriods: function getBillPeriods() {
                    //for caching, this should match the one in ss-bill-history-graph.js, which has count=6 (or ss-bill-latest, which has count=1 - or they should both be the 6 and share)
                    return SelcommWS.cached.post("Bill", "BillList", {
                        PagingSortsAndFilters: {
                            SkipRecords: 0,
                            TakeRecords: 6,
                            Sorts: [{
                                TargetProperty: "Sequence",
                                Direction: "Descending"
                            }]
                        }
					});
				}
			},
			// Define properties with getter/setters
			properties: {

			},
      constructor: ["$scope", "$watch", "$self", function ($scope, $watch, vm) {
        console.log("non-dis");
        console.log(vm.service);
                $watch.group({ newServiceId: "vm.service.Id", billPeriodCode: "vm.billPeriod.BillPeriod.Code" }, function ($new) {
                    if ($new.newServiceId) {
                        vm.loading = vm.loadUsageItems($new.newServiceId, $new.billPeriodCode).then(function successFunction(result) {
							vm.usageItems = result;
						});
					}
				});

                vm.getBillPeriods().then(function (billPeriods) { vm.billPeriods = billPeriods; });
			}]
		}
	};
});
